import SpreadsheetsDetails from "../components/SpreadsheetsDetails"
import { LandingNavbar } from "../components/Homepage/landing-navbar"

const AssistantsSpreadsheetsPage = () => {
    return (
    <main className="h-full bg-[#111827] overflow-auto">
        <div className="mx-auto max-w-screen-xl h-full w-full">
            <LandingNavbar />
            <SpreadsheetsDetails />
        </div>
      </main>
    )
}

export default AssistantsSpreadsheetsPage